youbora.registerAdapter('Freewheel', require('./adapter'))
  //module.exports = youbora


//////////////////
// WEBPACK FOOTER
// ./src/sp.js
// module id = 51
// module chunks = 0